export enum DialogTypes {
  WITHDRAWAL = 'WITHDRAWAL',
  DEPOSIT = 'DEPOSIT',
  DAY_CLOSED_NOTIFICATION = 'DAY_CLOSED_NOTIFICATION',
}
